'use client';

import type { ReactNode } from 'react';
import clsx from 'clsx';
import { Button } from '@publishing/components/ui/Button';
import Icon from '@publishing/components/ui/Icon';
import { ActionCloseType1 } from '@publishing/components/ui/SvgSprite';

import styles from './FormPopup.module.scss';

export type FormLayerPopupProps = {
  title: string;
  onClose: () => void;
  children: ReactNode;
  /** FormPopup single 레이아웃과 동일한 폭 (기본 true) */
  single?: boolean;
  className?: string;
};

/** CommonPopup 레이어 안에서 FormPopup과 동일한 셸(헤더·닫기)로 커스텀 콘텐츠를 감쌉니다. */
export default function FormLayerPopup({
  title,
  onClose,
  children,
  single = true,
  className,
}: FormLayerPopupProps) {
  return (
    <section
      className={styles.overlay}
      aria-label={title}
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={clsx(styles.popup, single && styles.popup_single, className)}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.head}>
          <strong>{title}</strong>
          <Button
            type="black"
            theme="icon"
            filled
            size={[32, 24]}
            bgColor="var(--color-alpha-white-5)"
            onClick={onClose}
            className={styles.close_button}
            aria-label="팝업 닫기"
          >
            <Icon name={ActionCloseType1} size={[16, 24]} />
          </Button>
        </div>
        {children}
      </div>
    </section>
  );
}
